<template>
    <div class="input-class d-flex align-items-center gap-2 mb-3 px-2">
        <div class="search-wrapper position-relative">
            <InputText v-model="localSearch" :placeholder="$t('search')" class="" />
            <i class="pi pi-search search-icon" />
        </div>

        <div class="d-flex align-items-center gap-1">
            <button class="btn btn-link p-0" @click="clearFilters" style="text-decoration: none;">
                <i style="color: #5d5f62;" class="pi pi-times-circle"></i>
                <strong class="clear-text">{{ $t("clear") }}</strong>
            </button>
        </div>

        <span v-if="isMultiSelectVisible" class="mx-1 gray-color">|</span>

        <span v-if="isMultiSelectVisible" class="search-text">{{ $t("filterBy") }} </span>
        <MultiSelect v-if="isMultiSelectVisible" v-model="localStatus" :options="statusOptions" optionLabel="label" optionValue="value"
            placeholder="Select status" :maxSelectedLabels="3" />
    </div>
</template>

<script setup>
import { ref, watch, defineProps, defineEmits } from 'vue';

const props = defineProps({
    search: String,
    status: {
        type: Array,
        default: () => []
    },
    isMultiSelectVisible: {
        type: Boolean,
        default: true
    }
});

const emit = defineEmits(['update:search', 'update:status', 'clear']);

const localSearch = ref(props.search || '');
const localStatus = ref(Array.isArray(props.status) ? props.status : []);

watch(localSearch, (val) => emit('update:search', val));
watch(localStatus, (val) => emit('update:status', val));

function clearFilters() {
    localSearch.value = '';
    localStatus.value = [];
    emit('clear');
}

const statusOptions = [
    { label: 'Enabled', value: 'enabled' },
    { label: 'Disabled', value: 'disabled' }
];
</script>

<style scoped>
.search-wrapper {
    position: relative;
}

.search-icon {
    position: absolute;
    right: 10px;
    top: 50%;
    transform: translateY(-50%);
    color: #6c757d;
    padding-left: 5px;
    border-left: 1px solid #D2D9E2;
}
 .p-inputtext {
    padding: 0.25rem 0.25rem;
    font-size: 0.875rem;
    background: transparent;
}
::v-deep(.p-multiselect .p-multiselect-label) {
    font-size: 0.875rem;
    padding: 0.25rem 0.25rem !important;
}
.p-multiselect {
    background: transparent !important;
}
.clear-text {
    color: #5d5f62;
    font-size: 0.875rem;
    margin-left: 5px;
}

.search-text {
    color: #5d5f62;
    font-size: 0.875rem;
}
</style>
